export function HasFieldCondition(fieldName) {
  // return ({ content }) => content && Object.hasOwn(content, fieldName);
  return ({ content }) => content && content.hasOwnProperty(fieldName);
}

export function NotContentTypeCondition(contentTypes) {
  return ({ content }) => !contentTypes.includes(content?.['@type']);
}
